import { rowLabel, type RowLabel } from './rowLabel.js';

/** The slice of a studio option `studioLabelOf` needs — `components/StudioSelect/StudioSelect.js`'s `StudioOption` satisfies it structurally. */
export type StudioOptionLike = { id: string; title: string | null };

/**
 * A studio's label for the Games page's `?studio=` filter: title from the already-loaded options
 * list, falling back to a slower per-studio read (its own record, while the options list is still
 * in flight) and, with neither, the id alone. `null` when there is no studio to label.
 */
export const studioLabelOf = (
    options: StudioOptionLike[] | undefined,
    id: string | null,
    fallback: string | null,
): RowLabel | null => {
    if (!id) return null;
    const option = options?.find((o) => o.id === id);
    return rowLabel(option?.title ?? fallback, id);
};
